import React from 'react';
import { 
  FaFacebook, 
  FaLinkedin, 
  FaYoutube, 
  FaInstagram, 
  FaTiktok,
  FaEnvelope, 
  FaArrowUp
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <div className="footer-logo">
                <img src="/assets/IEEElogo.png" alt="IEEE WIE Logo" />
                <span>IEEE WIE UoM</span>
              </div>
              <p className="footer-description">
                Empowering women in engineering and technology at University of Moratuwa. 
                Join us in creating innovative solutions and breaking barriers in STEM fields.
              </p>
              <div className="footer-social">
                <a href="https://www.facebook.com/WIEUOM/" className="social-icon facebook">
                  <FaFacebook />
                </a>
                <a href="https://www.linkedin.com/company/ieeewieuom/" className="social-icon linkedin">
                  <FaLinkedin />
                </a>
                <a href="https://www.youtube.com/channel/UCOq_KTOv3pUNpAiQ4O-CUqw" className="social-icon youtube">
                  <FaYoutube />
                </a>
                <a href="https://www.instagram.com/wie_uom/" className="social-icon instagram">
                  <FaInstagram />
                </a>
                <a href="https://www.tiktok.com/@ieee_wie_uom" className="social-icon tiktok" target="_blank" rel="noopener noreferrer">
                  <FaTiktok />
                </a>
                <a href="mailto:ieeewieuom@gmail.com" className="social-icon email">
                  <FaEnvelope />
                </a>
              </div>
            </div>
            
            <div className="footer-links">
              <h4>Quick Links</h4>
              <ul>
                <li><button onClick={() => scrollToSection('home')}>Home</button></li>
                <li><button onClick={() => scrollToSection('vision-mission')}>Vision & Mission</button></li>
                <li><button onClick={() => scrollToSection('projects')}>Projects</button></li>
                <li><button onClick={() => scrollToSection('awards')}>Awards</button></li>
                <li><button onClick={() => scrollToSection('team')}>Team</button></li>
                <li><button onClick={() => scrollToSection('gallery')}>Gallery</button></li>
                <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
              </ul>
            </div>
            
            <div className="footer-links">
              <h4>Programs</h4>
              <ul>
                <li><span>Mentorship Program</span></li>
                <li><span>Technical Workshops</span></li>
                <li><span>Research Projects</span></li>
                <li><span>Community Outreach</span></li>
                <li><span>Career Development</span></li>
              </ul>
            </div>
            
            <div className="footer-contact">
              <h4>Contact Info</h4>
              <div className="contact-info">
                <p>
                  <strong>Email:</strong><br />
                  ieeewieuom@gmail.com
                </p>
                <p>
                  <strong>Address:</strong><br />
                  University of Moratuwa<br />
                  Katubedda, Moratuwa 10400<br />
                  Sri Lanka
                </p>
               
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="copyright">
              © 2025 IEEE Women in Engineering University of Moratuwa. All rights reserved.
            </p>
          </div>
        </div>
      </div>
      
      <button className="scroll-to-top" onClick={scrollToTop}>
        <FaArrowUp />
      </button>
    </footer>
  );
};

export default Footer;
